'use strict';

var decoders = exports;
decoders.der = require('./der');
decoders.pem = require('./pem');